
import { useState, useEffect} from "react";

import Config from "../Config";

import input_check from "../input_check.png";
import input_error from "../input_error.png";


import GroupNew from "../modules/kids/GroupNew";

function InputComboStawkiWyzMulti(props)
{

    
    const [gr, setGr] = useState(null);

    const [refreshView, setRefreshView] = useState(props.userData.refreshView);
    
    
    
    const [val, setVal] = useState(props.value);
    const [req, setRequired] = useState(props.req);
    const [cn, setClassName] = useState('');

    const [onShow,setOnShow] = useState(false);

    const [view, setView] = useState ( {
        v:'list',
        id: -1
    } );


    

    const getGr = () => {
       
 
        props.mainView.setProgress(-2);

       

        fetch( Config.url + '/rest_v1_kids,free_st', {
            method: 'POST', 
            body: JSON.stringify({
                typ_st: '1', //kazde..
            }), 
            headers: {
                'Content-Type': 'application/json',                    
                'X-Api-Key': props.userData.apiKey,
                '_p_przedszkole_id_': props.userData.p_przedszkole_id,
                '_p_dziecko_id_': props.userData.p_dziecko_id,
                '_sec_key_': Config.genXKey() ,
            }
         })
         .then(res => res.json() )
         .then(res => { 

                    props.mainView.setProgress(-1);        
                    if(res._sys_ == undefined)
                    {
                        props.mainView.showDialog( "Error", "No correct response from server" , "ok" , null);  
                        setGr([]); 
                    }else
                    if(res.status != undefined && res.status == 'ERROR'  && res.result != undefined )
                    {
                        props.mainView.showDialog( "Error", JSON.stringify(res.result) , "ok" , null);  
                        setGr([]); 
                    }else    
                    {                       
                       // setGr(res.result);    
                       
        
                       //oznacz zaznaczone..
                       var newVal = val;
                       if(newVal == null || newVal == undefined) newVal = "";                
                       var ids = newVal.split(',');  
           
                       var p = new Array();
                       for(var m=0; m< res.result.length; m++)
                       {
                           var sel = false;
           
                           for(var mx=0;mx<ids.length; mx++)
                               {
                                   if( parseInt( ids[mx]) == parseInt( res.result[m].v )    ) sel = true;
                               }
                              
           
                           var n = {
                               selected: sel,
                               v: res.result[m].v,
                               title: res.result[m].title,
                           }
                           p.push(n);
                       }
           
                      setGr(p);


                                
                    }
         } )
         .catch(err => {          
                    setGr([]); 
                    props.mainView.showDialog( "Error", "I: " + err , "ok" , null);
                    props.mainView.setProgress(-1);
         });
                   

         return false;
    }

   
 


    if(refreshView != props.userData.refreshView)
        {                     
            setRefreshView( props.userData.refreshView);
            setGr(null);    

            setView({
                v:'list',
                id: -1
            });

        }





    if(cn.length < 2)
    {
        var correct = true;
        
        if(req == '1' && val != undefined && val == '_x_') correct = false;         
    
      
        if(correct == false)
        {
            setClassName('incorrent');
        }else
        {
            setClassName('corrent');           
        }
    }


    var imgx = null;

    if(cn == "incorrent" && req=='1')
    {
        imgx = <img  className="input_status" src={input_error} />
    }

    
    if(cn == "corrent" && req=='1')
    {
        imgx = <img className="input_status" src={input_check} />
    }



    useEffect(() => {


   

        if(val != props.value && props.value != undefined) //aktualizuj jesli sie zmieni..
        {
            setVal(props.value);
            setOnShow(false);
        }

        if( onShow == false && props.valChange != null && props.valChange != undefined ) //sprawdz czy dane sa poprawne i wyslij wyzej
        {
             var correct = true;
             if(cn == "incorrent" ) correct = false;                 
             setOnShow(true);
             props.valChange(props.name, val, correct,'');
    
        }
    })



    const onBack = (id) => {                 
        
        setVal(id);
        setGr(null);
       
  
        
        setView({
            v: 'list',
            id: -1
        });
    }


    const onClick = (e) => {

      //  console.log('StView', view);

        if(view.v == 'list')
            {
                setView({
                    v:'select',
                    id: -1
                });
             
            } 

        e.target.blur();     
    }


    const onSelect = (e) => {

            if(gr == null) return;

 

            var id = e.target.getAttribute("id");
            var checked = e.target.checked;

           

                        var p = new Array();
                        for(var m=0; m< gr.length; m++)
                        {
                            var s = gr[m].selected;

                            if(gr[m].v == id) s = checked;

                            var n = {
                                selected: s,
                                v: gr[m].v,
                                title: gr[m].title,
                            }
                            p.push(n);

                           

                        }                
                        setGr(p);
                        


    }



    const onClose = () => {
       
        setView({
            v:'list',
            id: -1
        });

        var list = "";


        if(gr != null)
        {
            for(var m=0; m< gr.length; m++)
                {           
                    if(gr[m].selected)  
                    {
                        if(list != "") list =  list + ",";

                        list = list + gr[m].v;
                    }
                }

        }

        

        if(props.valChange != null && props.valChange != undefined)
            {
                props.valChange(props.name, list, true, 'combo');
            }else
            {
                console.log('No support for valChange');
            }
    }


    var dlg = null;



  
    
   
   

    
    if( gr == null   )
    {
      
        getGr();
      
        
        return <fieldset>
                     <input type="text"  value="..." name={props.name} placeholder={props.placeholder} className={props.className + "   " + cnX} /> 
                    {imgx}
             <br/>
             <span className="form_err">  &nbsp; </span>   
             {dlg}          
           </fieldset>                     
        
    }


 
    if(props.value != val )
    {
        setVal(props.value);  



        var goRefresh = false;
        //oznacz zaznaczone..
        var newVal = props.value;
        if(newVal == null || newVal == undefined) newVal = "";                
        var ids = newVal.split(',');  

        var p = new Array();
        for(var m=0; m< gr.length; m++)
        {
            var sel = false;

            for(var mx=0;mx<ids.length; mx++)
                {
                    if( parseInt( ids[mx]) == parseInt( gr[m].v )    ) sel = true;
                }

                if(gr[m].selected != sel ) {goRefresh = true; }

            var n = {
                selected: sel,
                v: gr[m].v,
                title: gr[m].title,
            }
            p.push(n);
        }

        if(goRefresh)setGr(p);


        return <fieldset>
                    <input type="text"  value="..." name={props.name} placeholder={props.placeholder} className={props.className + "   " + cnX} /> 
                    {imgx}
                <br/>
                <span className="form_err">  &nbsp; </span>   
                {dlg}          
                </fieldset>   
    }


  

       
     

    
 

    var iloscWybranych = 0;
    if(gr != null)
        {
            for(var m=0; m< gr.length; m++)
                {           
                    if(gr[m].selected) iloscWybranych++;         
                }
        }


        if(view.v == 'select')
            {
                dlg = <div className="dlg_window dlg_type_y shadowx">
                        <div className="dlg_title">Wskaż jedną lub wiele stawek</div>
                        <div className="dlg_content_x scroll200">
                            <ul>
                                {
                                    gr.map( (item, ix) => {
        
                                        var checked = "";
                                        if(item.selected) checked = "checked";
        
                                        return <li>
                                            <input type="checkbox" id={item.v} checked={checked} onChange={onSelect} /> {item.title}
                                        </li>
                                    } )
                                }
                            </ul>
                        </div>       
                        <div className="dlg_btn">
                             <div className="btn" onClick={onClose}>zamknij</div>
                           
                        </div>
                     </div>
            }
             




    var err = "";
    if(props.err != undefined  &&  props.err != null ) 
    {       
        if(props.err[props.name] != null  && props.err[props.name] != undefined    ) err = props.err[props.name]['param'];
    }




    var cnX = cn;
    if(val.length < 1 && cnX == 'corrent')
        {
            cnX = '';
        }


     var info = "Wybrano: "+iloscWybranych;        


    


    return <fieldset>
          
            <input type="text"   value={info}  onClick={onClick} onFocus={onClick} name={props.name} placeholder={props.placeholder} className={props.className + "   " + cnX} /> 

             {imgx}
             <br/>
             <span className="form_err">{err + " "} &nbsp; </span>             
             {dlg}
           </fieldset>
}


export default InputComboStawkiWyzMulti;

